import React, { useEffect, useState } from "react";
import { Input } from "../../components/ui/input"; // your custom tailwind input
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "antd";
import { loginAPI } from "./LoginApi";
import { Input as AntdInput } from "antd";
import { Link, useNavigate } from "react-router-dom";
import GoogleComponent from "../../components/VibrantSolComponents/GoogleLoginButton";

function SignInModal({ onClose, onSignUp }) {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const loading = useSelector((state) => state.GlobalSpinner.loader);

  // Normal Login
  const handleSubmit = async (values) => {
    try {
      const res = await dispatch(loginAPI(values));
      if (res) {
        const authData = JSON.stringify(res);

        if (values.remember) {
          localStorage.setItem("token", authData); // persistent
        } else {
          sessionStorage.setItem("token", authData); // clears on tab/browser close
        }

        form.resetFields();
        onClose();
        navigate("/dashboard", { replace: true });
      }
    } catch (errorInfo) {
      console.log("Failed:", errorInfo);
    }
  };

  useEffect(() => {
    form.resetFields();
  }, [form]);

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center">
      <div className="bg-white rounded-xl shadow-2xl p-8 relative w-full max-w-md">
        <button
          className="absolute top-3 right-3 text-gray-500 hover:text-black text-2xl"
          onClick={() => {
            form.resetFields();
            onClose();
          }}
          aria-label="Close"
        >
          &times;
        </button>
        <h2 className="text-3xl font-bold mb-2 text-center secdory-font">
          Sign In
        </h2>
        <p className="text-center text-gray-600 mb-6">
          Sign in with email and password
        </p>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          className="space-y-4"
        >
          <Form.Item
            name="userName"
            rules={[{ required: true, message: "Please enter your user name" }]}
          >
            <Input
              type="text"
              maxLength={100}
              placeholder="Enter user name (100 characters max)"
              autoComplete="new-password"
              className="w-full px-4 py-3 border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: "Please enter your password" }]}
          >
            <AntdInput.Password
              maxLength={100}
              placeholder="Enter password (100 characters max)"
              autoComplete="new-password"
            />
          </Form.Item>
          <div className="flex justify-between items-center mt-2">
            <Form.Item name="remember" valuePropName="checked" noStyle>
              <label className="flex items-center text-sm text-gray-700">
                <input type="checkbox" className="mr-2 accent-primary" />
                Stay signed in
              </label>
            </Form.Item>
            {/* <a
              href="#"
              className="text-sm text-gray-600 hover:underline ml-auto"
            >
              Forgot your password?
            </a> */}
            <Link
              to="/forgotpassword"
              className="text-sm text-gray-600 hover:underline"
            >
              Forgot Password?
            </Link>
          </div>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading} // <- this works in AntD Button
            className="w-full py-3 rounded-md font-semibold"
          >
            Log In
          </Button>
        </Form>
        <p className="text-center text-gray-600 mt-6">
          Don’t have an account yet?{" "}
          <span
            className="text-black font-semibold cursor-pointer"
            onClick={onSignUp}
          >
            Sign up
          </span>
        </p>
        <div className="my-4 flex items-center">
          <div className="flex-grow border-t border-gray-200"></div>
          <span className="mx-3 text-gray-400">or Log-in with</span>
          <div className="flex-grow border-t border-gray-200"></div>
        </div>
        <div className="flex gap-4">
          <button className="flex-1 flex items-center justify-center gap-2 border border-gray-300 rounded-md py-2 font-medium hover:bg-gray-50">
            <svg class="w-5 h-5 mr-2" fill="#1877F2" viewBox="0 0 24 24">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"></path>
            </svg>
            Facebook
          </button>
          {/* Google Login Button */}
          <GoogleComponent />
        </div>
      </div>
    </div>
  );
}

export default SignInModal;
